import { render, staticRenderFns } from "./ProductGroupShowButton.vue?vue&type=template&id=6721db98&scoped=true&"
import script from "./ProductGroupShowButton.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroupShowButton.vue?vue&type=style&index=0&id=6721db98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721db98",
  null
  
)

export default component.exports